import { create } from "zustand";

/**
 * Favoriler sayfasının sayfalama state'i.
 *
 * Ayrı bir store, çünkü hem ızgara hem sayfalama çubuğu aynı sayfayı
 * okumalı ve ikisi de prop almıyor (zero prop drilling).
 */

interface FavoritesListStore {
  page: number;
  setPage: (page: number) => void;
  reset: () => void;
}

export const useFavoritesListStore = create<FavoritesListStore>((set) => ({
  page: 1,
  setPage: (page) => set({ page: Math.max(1, page) }),
  reset: () => set({ page: 1 }),
}));
